import { useTranslationWithPrefix } from '@hotjar/translations';
import { Button } from '@hotjar/hotsauce';
import { ManageSubscriptionButton } from '~/subscription-management/components';
import { FORM_ID } from '~/subscription-management/components/invoice-details/form/InvoiceDetailsForm';
import { CHECKOUT_FOOTER_CTA, trackClick } from '~/subscription-management/utils/tracking';

interface Props {
  onClickSkip(): void;
  isLoading: boolean;
  isDisabled: boolean;
  skipPaymentDetails: boolean;
  hasErrored: boolean;
  accountId: number;
}

export const InvoiceDetailsFooter = ({
  onClickSkip,
  isDisabled,
  isLoading,
  skipPaymentDetails,
  hasErrored,
  accountId,
}: Props): JSX.Element => {
  const { t: tFooter } = useTranslationWithPrefix('checkout:footer');

  const getPrimaryButtonText = (): string => {
    if (hasErrored) {
      return tFooter('try-again');
    }
    return tFooter('invoice-details', { context: skipPaymentDetails ? 'skip' : '' });
  };

  return (
    <>
      {hasErrored && (
        <Button
          kind="secondary"
          isLoading={isLoading}
          isDisabled={isDisabled}
          onClick={onClickSkip}
        >
          {tFooter('skip')}
        </Button>
      )}
      <ManageSubscriptionButton
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={() =>
          trackClick({
            eventName: CHECKOUT_FOOTER_CTA.invoiceDetails,
            accountId,
            uiPosition: 'Checkout Footer',
          })
        }
        formId={FORM_ID}
      >
        {getPrimaryButtonText()}
      </ManageSubscriptionButton>
    </>
  );
};
